import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FaceWink"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM15.375 8.25C14.3395 8.25 13.5 9.08947 13.5 10.125C13.5 11.1605 14.3395 12 15.375 12C16.4105 12 17.25 11.1605 17.25 10.125C17.25 9.08947 16.4105 8.25 15.375 8.25ZM6 9.75H10.5V11.25H6V9.75ZM17.1374 15.0825C16.0555 16.8891 14.1057 17.9964 11.9999 18C9.89408 17.9964 7.94427 16.8891 6.8624 15.0825L8.1449 14.3325C8.959 15.6844 10.4218 16.5111 11.9999 16.5111C13.578 16.5111 15.0408 15.6844 15.8549 14.3325L17.1374 15.0825ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FaceWink.vue"]]);
